import { IonItem, IonLabel } from "@ionic/react";

import { translate } from "~utils";

type TimeZoneDisclaimerProps = {
  isSuperAdmin: boolean;
  schoolName?: string;
  timeZone?: string;
  hideHeader?: boolean;
};

export function TimeZoneDisclaimer(props: TimeZoneDisclaimerProps) {
  const { schoolName, timeZone, isSuperAdmin: isSuperadmin, hideHeader = false } = props;

  return (
    <IonItem lines="none">
      <div className="w-full">
        {!hideHeader && (
          <IonLabel className="pt-3 pb-3 font-medium">
            {translate("MULTI_DAY_EDIT_TIMES_LABEL")}
          </IonLabel>
        )}

        {isSuperadmin &&
          translate("TIMEZONE_DISCLAIMER_LABEL", {
            schoolName: schoolName || "",
            timeZone: timeZone,
          })}
      </div>
    </IonItem>
  );
}
